export interface ProductoLineaInvestigacionDTO{
    iddecinvproductolineainvestigacion: number, 
    iddecinvproyectoprodtermin: number, 
    iddecinvtipoproductoesperado:number, 
    iddecinvareaconocimiento: number, 
    lineainvestigacion: string,
    ultimoCambio:string,
}

export function getVoidProductoLineaInvestigacionDTO(): ProductoLineaInvestigacionDTO{
    return{
        iddecinvproductolineainvestigacion: 0, 
        iddecinvproyectoprodtermin: 0, 
        iddecinvtipoproductoesperado: 0, 
        iddecinvareaconocimiento: 0, 
        lineainvestigacion: '',
        ultimoCambio:'',
    }
}

export function setProductoLineaInvestigacionDTO(data: any): ProductoLineaInvestigacionDTO{
    return{ 
        iddecinvproductolineainvestigacion: data.iddecinvproductolineainvestigacion??0,
	    iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
	    iddecinvtipoproductoesperado: data.iddecinvtipoproductoesperado??0,
	    iddecinvareaconocimiento: data.iddecinvareaconocimiento??0,
        lineainvestigacion: data.lineainvestigacion?? "", 
        ultimoCambio: data.ultimocambio,
    }
}